import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { WarehouseProductQuantityHistoryReasonType } from '../enums/warehouse-product-quantity-history-reason-type';

@Injectable({
  providedIn: 'root',
})
export class WarehouseProductQuantityHistoryReasonTypeProviderService {
  /* prettier-ignore */
  private entries = new Map<WarehouseProductQuantityHistoryReasonType, string>([
    [WarehouseProductQuantityHistoryReasonType.NewGood, 'Dodanie towaru, początkowy stan'],
    [WarehouseProductQuantityHistoryReasonType.ByReceipt, 'Przyjęcie towaru'],
    [WarehouseProductQuantityHistoryReasonType.ByRestock, 'Zwrot / reklamacja'],
    [WarehouseProductQuantityHistoryReasonType.ByRelease, 'Wydanie towaru'],
    [WarehouseProductQuantityHistoryReasonType.Manual, 'Zmiana ręczna'],
  ]);

  public label(
    type: WarehouseProductQuantityHistoryReasonType,
  ): Observable<string> {
    const entry = this.entries.get(type);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${type}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<
    SelectItem<WarehouseProductQuantityHistoryReasonType>[]
  > {
    const result = Array.from(this.entries.entries()).map(
      ([type, label]) => new SelectItem(label, type),
    );

    return of(result);
  }
}
